import React from 'react';
import '../css/Modal.css';
import Translate from "./Translate";
import {getCurrentUser} from "../services/authService";

const currentUser = getCurrentUser() ? getCurrentUser() : {language: 'en'};

const ConfirmModal = ({isOpen, onClose, onConfirm}) => {

    if (!isOpen) return null;

    console.log(onConfirm)

    return (
        <div className="modal-overlay" onClick={onClose}>
            <div className="modal-content" onClick={(e) => e.stopPropagation()}>
                <h3><Translate language={currentUser.language} text={'areYouSureContinue'}/></h3>
                <div className="modal-buttons">
                    <button className="modal-button cancel" onClick={onClose}><Translate language={currentUser.language}
                                                                                         text={'no'}/></button>
                    <button className="modal-button confirm"
                            onClick={() => {
                                onConfirm();
                                onClose();
                            }}
                    >
                        <Translate language={currentUser.language} text={'yes'}/>
                    </button>
                </div>
            </div>
        </div>
    );
};

export default ConfirmModal;
